export default __webpack_public_path__ + "static/media/a004-mary-left.acbbbc67.svg";